// src/services/exportService.js
import { 
  operatorReportPDF, 
  operatorReportsPDF 
} from './pdfTemplates';
import { 
  exportOperatorReportToExcel, 
  exportOperatorReportsToExcel,
  exportMeterReportsToExcel
} from './excelExport';
import pdfMake from 'pdfmake/build/pdfmake';

class ExportService {
  // Перевірка доступності pdfMake
  static isPdfMakeAvailable() {
    return pdfMake && typeof pdfMake.createPdf === 'function';
  }

  // Експорт одного звіту в PDF
  static exportReportToPDF(report) {
    try {
      if (!this.isPdfMakeAvailable()) {
        throw new Error('PDFMake no está disponible en este navegador');
      }

      const docDefinition = operatorReportPDF(report);
      pdfMake.createPdf(docDefinition).open();
      return true;
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw new Error('No se pudo generar el PDF: ' + error.message);
    }
  }

  // Експорт списку звітів в PDF
  static exportReportsToPDF(reports, filters = {}) {
    try {
      if (!this.isPdfMakeAvailable()) {
        throw new Error('PDFMake no está disponible en este navegador');
      }

      const docDefinition = operatorReportsPDF(reports, filters);
      pdfMake.createPdf(docDefinition).open();
      return true;
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw new Error('No se pudo generar el PDF: ' + error.message);
    }
  }

  // Експорт одного звіту в Excel
  static exportReportToExcel(report) {
    try {
      exportOperatorReportToExcel(report);
      return true;
    } catch (error) {
      console.error('Error generating Excel:', error);
      throw new Error('No se pudo generar el Excel');
    }
  }

  // Експорт списку звітів в Excel
  static exportReportsToExcel(reports, filters = {}) {
    try {
      exportOperatorReportsToExcel(reports, filters);
      return true;
    } catch (error) {
      console.error('Error generating Excel:', error);
      throw new Error('No se pudo generar el Excel');
    }
  }

  // Експорт даних лічильників в Excel
  static exportMeterReportsToExcel(reports, filters = {}) {
    try {
      exportMeterReportsToExcel(reports, filters);
      return true;
    } catch (error) {
      console.error('Error generating Excel for meters:', error);
      throw new Error('No se pudo generar el Excel para contadores');
    }
  }

  // Завантаження PDF (замість відкриття)
  static downloadReportPDF(report) {
    try {
      if (!this.isPdfMakeAvailable()) {
        throw new Error('PDFMake no está disponible en este navegador');
      }

      const docDefinition = operatorReportPDF(report);
      pdfMake.createPdf(docDefinition).download(`Reporte_Turno_${report.fecha}_${report.turno}.pdf`);
      return true;
    } catch (error) {
      console.error('Error downloading PDF:', error);
      throw new Error('No se pudo descargar el PDF: ' + error.message);
    }
  }

  // Масовий експорт
  static bulkExport(reports, format, filters = {}) {
    if (format === 'pdf') {
      return this.exportReportsToPDF(reports, filters);
    } else if (format === 'excel') {
      return this.exportReportsToExcel(reports, filters);
    }
    throw new Error('Formato no soportado');
  }
}

export default ExportService;


